<template>
  <v-container class="mt-16 pt-4">
    <h1 class="monkey-title text-h3 mb-12 mt-6 text-accent">Politique de confidentialité</h1>

    <v-card class="neu-sand px-5">
      <v-card-text>
        <p><span class="font-weight-bold">Meili</span>, un site de e-commerce édité par <span class="font-weight-medium">INFOGRAPHART</span> représenté ici par <span class="font-weight-medium">EI Stanislas Castaybert</span>, s'engage à protéger la vie privée de ses utilisateurs.</p>
        <p>Cette politique de confidentialité explique comment nous collectons, utilisons et partageons vos informations personnelles lorsque vous utilisez notre site web.</p>

        <h2 class="text-h4 mt-6 mb-3 text-accent">Informations collectées</h2>

        <p>Nous collectons les informations suivantes lorsque vous utilisez notre site web :</p>

        <ul class="pl-4">
          <li><span class="font-weight-bold">Informations de débogage :</span> Nous collectons des informations sur le comportement de l'utilisateur sur la boutique à des fins de crashalytics, de qualité de service et de maintenabilité. Cela peut inclure des informations sur votre navigateur, votre système d'exploitation, votre adresse IP et vos activités sur notre site web uniquement.</li>
          <li><span class="font-weight-bold">Informations de paiement :</span> Lorsque vous effectuez un achat via notre plateforme de paiement Stripe, nous collectons votre nom, votre prénom, votre adresse et votre type de paiement. Stripe a sa propre politique de confidentialité que vous pouvez consulter ici : <NuxtLink to="https://stripe.com/privacy" target="_blank">https://stripe.com/privacy</NuxtLink>.</li>
          <li><span class="font-weight-bold">Informations CRM :</span> Le CRM Katana récupère des données personnelles telles que nom, prénom, adresse, email et numéro de téléphone. Katana a sa propre politique de confidentialité que vous pouvez consulter ici : <NuxtLink to="https://katana-crm.com/privacy" target="_blank">https://katana-crm.com/privacy</NuxtLink></li>
          <li><span class="font-weight-bold">Cookie d'analyse des visites :</span> Nous utilisons un cookie d'analyse de visites Vercel pour suivre le trafic sur notre site web. Ce cookie ne collecte aucune information personnelle.</li>
          <li><span class="font-weight-bold">Cookie de sauvegarde du panier :</span> Nous utilisons un cookie pour sauvegarder le contenu de votre panier (articles, quantité) pour une meilleure expérience utilisateur. Ce cookie ne collecte aucune information personnelle.</li>
        </ul>

        <h2 class="text-h4 mt-6 mb-3 text-accent">Utilisation des informations</h2>

        <p>Nous utilisons les informations que nous collectons pour :</p>

        <ul class="pl-4">
          <li>Améliorer votre expérience sur notre site web</li>
          <li>Déboguer et résoudre des problèmes</li>
          <li>Respecter les lois et règlements applicables</li>
        </ul>

        <h2 class="text-h4 mt-6 mb-3 text-accent">Partage des informations</h2>

        <p>Nous ne partageons vos informations personnelles avec des tiers que dans les cas suivants :</p>

        <ul class="pl-4">
          <li>Avec votre consentement</li>
          <li>Avec des prestataires de services qui nous aident à exploiter notre site web, tels que Stripe et Katana</li>
          <li>Si nous sommes tenus de le faire par la loi</li>
        </ul>

        <h2 class="text-h4 mt-6 mb-3 text-accent">Vos droits</h2>

        <p>Vous disposez des droits suivants concernant vos informations personnelles :</p>

        <ul class="pl-4">
          <li>Le droit d'accès à vos informations personnelles</li>
          <li>Le droit de rectification de vos informations personnelles</li>
          <li>Le droit d'effacement de vos informations personnelles</li>
          <li>Le droit de limiter le traitement de vos informations personnelles</li>
          <li>Le droit de vous opposer au traitement de vos informations personnelles</li>
          <li>Le droit à la portabilité de vos informations personnelles</li>
        </ul>

        <p>Vous pouvez exercer ces droits en nous contactant à l'adresse <NuxtLink to="mailto:dpo@infographart.com" target="_blank">dpo@infographart.com</NuxtLink>.</p>

        <h2 class="text-h4 mt-6 mb-3 text-accent">Sécurité des informations</h2>

        <p>Nous prenons des mesures de sécurité pour protéger vos informations personnelles contre la perte, l'utilisation abusive et l'accès non autorisé. Cependant, aucune méthode de sécurité n'est infaillible et nous ne pouvons pas garantir la sécurité absolue de vos informations personnelles.</p>

        <h2 class="text-h4 mt-6 mb-3 text-accent">Modifications de cette politique de confidentialité</h2>

        <p>Nous pouvons modifier cette politique de confidentialité à tout moment. La version la plus récente de cette politique sera toujours publiée sur notre site web.</p>

        <h2 class="text-h4 mt-6 mb-3 text-accent">Contact</h2>

        <p>Si vous avez des questions sur cette politique de confidentialité, veuillez nous contacter à l'adresse <NuxtLink to="mailto:dpo@infographart.com" target="_blank">dpo@infographart.com</NuxtLink>.</p>

        <h2 class="text-h4 mt-6 mb-3 text-accent">Informations légales</h2>

        <p><span class="font-weight-medium">Retrouvez les informations légales sur nos</span> <NuxtLink to="/terms" class="text-decoration-none">Mentions légales</NuxtLink>.</p>
      </v-card-text>
    </v-card>

    <h5 class="mt-8"><span class="font-weight-medium">Dernière modification :</span> 08 juin 2024</h5>
  </v-container>
</template>

<script setup>
definePageMeta({
  title: "Politique de Confidentialité",
});
</script>

<script>
export default {
  name: "PrivacyPolicyPage",
};
</script>

<style scoped>
p {
  margin: 0.75rem 0;
}

h1 {
  text-align: center;
}
</style>
